import { __require as requireDefineProperties } from '../define-properties/index.js';
import { __require as requirePolyfill } from './polyfill.js';
import { __require as requireGopd } from '../gopd/index.js';
import { __require as requireEsErrors } from '../es-errors/index.js';
import { __require as requireGetProto } from '../get-proto/index.js';

var shim;
var hasRequiredShim;

function requireShim () {
	if (hasRequiredShim) return shim;
	hasRequiredShim = 1;

	var supportsDescriptors = requireDefineProperties().supportsDescriptors;
	var getPolyfill = requirePolyfill();
	var gOPD = /*@__PURE__*/ requireGopd();
	var defineProperty = Object.defineProperty;
	var $TypeError = /*@__PURE__*/ requireEsErrors();
	var getProto = requireGetProto();
	var regex = /a/;

	shim = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};
	return shim;
}

export { requireShim as __require };
